import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getLicenseFromCheckoutSessionOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { notifyLicenseDetailsChanged } from "@/lib/license-details-change-notification";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link, createFileRoute } from "@tanstack/react-router";
import { Home } from "lucide-react";
import * as React from "react";

export const Route = createFileRoute("/registrant/payment-success")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    sessionId:
      typeof search.sessionId === "string" ? search.sessionId : undefined,
  }),
});

function RouteComponent() {
  const queryClient = useQueryClient();
  const { sessionId } = Route.useSearch();

  const { data: licenseFromSession, isLoading: isLicenseFromSessionLoading } =
    useQuery({
      ...getLicenseFromCheckoutSessionOptions({
        path: {
          checkout_session_id: sessionId ?? "",
        },
      }),
      enabled: !!sessionId,
    });

  React.useEffect(() => {
    void notifyLicenseDetailsChanged(
      queryClient,
      licenseFromSession?.license_id ?? null,
    );
  }, [queryClient, licenseFromSession?.license_id]);

  const licenseIdFromSession = licenseFromSession?.license_id;

  return (
    <div className="w-full space-y-6">
      <div className="flex flex-col container mx-auto max-w-3xl">
        <Card className="text-center">
          <CardHeader>
            <CardTitle className="text-xl font-semibold tracking-tight">
              Payment Processed
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4 text-sm text-muted-foreground">
            <p className="text-muted-foreground">
              Thank you for your payment. Your registration has been
              successfully processed. You can view your current registrations
              from your dashboard.
            </p>
            <p className="text-muted-foreground">
              If you paid with a credit card, your license has already been sent
              for review.
            </p>
            <p className="text-muted-foreground">
              If you paid via a bank transfer, it may take up to 2 business days
              until your payment can be confirmed for your license to be
              forwarded to our reviewers.
            </p>
          </CardContent>
          <CardFooter className="flex justify-center">
            {sessionId && isLicenseFromSessionLoading ? (
              <Button size="lg" disabled>
                <Home className="h-5 w-5 mr-2" />
                Go to Dashboard
              </Button>
            ) : licenseIdFromSession ? (
              <Link
                to="/registrant/dashboard"
                search={{
                  openLicense: licenseIdFromSession,
                  focusProperty: true,
                }}
              >
                <Button>
                  <Home className="h-5 w-5 mr-2" />
                  Go to Dashboard
                </Button>
              </Link>
            ) : (
              <Link to="/registrant/dashboard">
                <Button>
                  <Home className="h-5 w-5 mr-2" />
                  Go to Dashboard
                </Button>
              </Link>
            )}
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
